import { Modal } from "react-bootstrap";
import Popup from "../../../../Helpers/Popup/Popup";
import PopupTitle from "../../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../../Helpers/CloseBtn/Close";

import React, { useContext, useEffect, useState } from "react";
import Table from "../../../../Helpers/Table/Table";
import Pagination from "../../../../Helpers/Pagination/Pagination";
import { filtrationcontext } from "../../../../../context/Filtercontext";
import Searchbar from "../../../../Helpers/Searchbar/Searchbar";
import trans from "../../../../../utils";
import VehiclesTable from "../TotalsTableBody/TotalVechiclesTable";
import DriversTable from "../TotalsTableBody/TotalDriversTable";
import TotalFuelTable from "../TotalsTableBody/TotalFuelTable";
import TotalUsersTable from "../TotalsTableBody/TotalUsersTable";

const TotalPopup = ({ title, setTotalPopup }) => {
  const { limit, setLimit, setSearchQuery } = useContext(filtrationcontext);

  const [query, setQuery] = useState("");
  const handleSearch = (e) => {
    setQuery(e.target.value);
    setSearchQuery(e.target.value);
  };
  useEffect(() => {
    return () => setSearchQuery("");
  }, [setSearchQuery]);
  let HeadField = [];
  let type = "";
  if (title === "Total Drivers") {
    HeadField = [
      trans("Name"),
      trans("driver code"),
      trans("ID number"),
      trans("phone number"),
      trans("Address"),
      trans("Contract Expiry"),
      trans("License Expiry"),
    ];
    type = "TotalDrivers";
  } else if (title === "Total Users") {
    HeadField = [trans("Name"), trans("Phone"), trans("Email"), trans("Role")];
    type = "TotalUsers";
  } else {
    HeadField = ["Vehicle", "IMEI", "Address", "SOS Time", "Alert Time"];
    type = "sosAlert";
  }

  return (
    <Popup show={!!title} size={"xl"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={`${trans(title)}`} style="" nospace={true} />
        </Modal.Title>
        <Close
          // eslint-disable-next-line react/style-prop-object
          style="close-32 close"
          close={() => setTotalPopup("")}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <Searchbar
          style="search search-dark input-group"
          path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
          placeholder={trans("Search")}
          value={query}
          onChange={handleSearch}
        />
        {title === "Total Vehicles" ? (
          <VehiclesTable
            query={query}
            limit={limit}
            setLimit={setLimit}
            setQuery={setQuery}
          />
        ) : title === "Total Drivers" ? (
          <DriversTable
            query={query}
            limit={limit}
            setLimit={setLimit}
            setQuery={setQuery}
          />
        ) : title === "Fuel Cost" ? (
          <TotalFuelTable
            query={query}
            limit={limit}
            setLimit={setLimit}
            setQuery={setQuery}
          />
        ) : (
          <>
            <TotalUsersTable
              query={query}
              limit={limit}
              setLimit={setLimit}
              setQuery={setQuery}
            />
          </>
        )}
      </Modal.Body>
    </Popup>
  );
};

export default TotalPopup;
